import { render } from "./MinistryEventsTable.vue?vue&type=template&id=961bbaf6&scoped=true&ts=true"
import script from "./MinistryEventsTable.vue?vue&type=script&lang=ts"
export * from "./MinistryEventsTable.vue?vue&type=script&lang=ts"

import "./MinistryEventsTable.vue?vue&type=style&index=0&id=961bbaf6&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-961bbaf6"]])

export default __exports__